import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentUser } from '@/server/functions/auth';

export const Route = createFileRoute('/_auth')({
    component: AuthLayout,
    loader: async ({ location }) => {
        const currentUser = await getCurrentUser();
        const passthrough =
            location.pathname === '/sign-out' || location.pathname === '/invite';

        if (currentUser && !passthrough) {
            throw redirect({ to: '/admin' });
        }

        return { currentUser };
    },
});

function AuthLayout() {
    return <Outlet />;
}
